import * as PropTypes from 'prop-types';
import * as React from 'react';

import {
  Tooltip,
  SanitizedRender,
} from '@reverbdotcom/discovery-ui';

function TooltipWrapper(props) {
  const {
    triggerHtml,
    text,
    placement,
    ariaLabel,
    removeButtonWrapper,
  } = props;

  let children = <SanitizedRender html={triggerHtml} />;

  if (!removeButtonWrapper) {
    children = (
      <button type="button" className="tooltip__trigger--button-reset" aria-label={ariaLabel}>
        {children}
      </button>
    );
  }

  return (
    <Tooltip
      type="plain"
      text={text}
      placement={placement}
    >
      {children}
    </Tooltip>
  );
}

TooltipWrapper.propTypes = {
  placement: PropTypes.oneOf('top', 'bottom', 'left', 'right'),
  triggerHtml: PropTypes.string.isRequired, // children should be passed in as an html string
  text: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  removeButtonWrapper: PropTypes.bool,
};

TooltipWrapper.defaultProps = {
  removeButtonWrapper: false,
  ariaLabel: undefined,
  placement: 'top',
};


export default TooltipWrapper;



// WEBPACK FOOTER //
// ./javascripts/components/tooltip_wrapper.jsx